/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSubbrandLookupDto,
  SubbrandLookupResponseDto,
  UpdateSubbrandLookupDto,
} from '../models/index';
import {
    CreateSubbrandLookupDtoFromJSON,
    CreateSubbrandLookupDtoToJSON,
    SubbrandLookupResponseDtoFromJSON,
    SubbrandLookupResponseDtoToJSON,
    UpdateSubbrandLookupDtoFromJSON,
    UpdateSubbrandLookupDtoToJSON,
} from '../models/index';

export interface CreateSubbrandRequest {
    createSubbrandLookupDto: CreateSubbrandLookupDto;
}

export interface GetAllSubbrandsRequest {
    isActive?: boolean;
    brandLookupId?: number;
}

export interface GetSubbrandRequest {
    id: number;
}

export interface GetSubbrandsByBrandRequest {
    brandLookupId: number;
    isActive?: boolean;
}

export interface UpdateSubbrandRequest {
    id: number;
    updateSubbrandLookupDto: UpdateSubbrandLookupDto;
}

/**
 * 
 */
export class SubBrandLookupServiceApi extends runtime.BaseAPI {

    /**
     */
    async createSubbrandRaw(requestParameters: CreateSubbrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubbrandLookupResponseDto>> {
        if (requestParameters['createSubbrandLookupDto'] == null) {
            throw new runtime.RequiredError(
                'createSubbrandLookupDto',
                'Required parameter "createSubbrandLookupDto" was null or undefined when calling createSubbrand().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subbrand-lookup/subbrands`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSubbrandLookupDtoToJSON(requestParameters['createSubbrandLookupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubbrandLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async createSubbrand(requestParameters: CreateSubbrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubbrandLookupResponseDto> {
        const response = await this.createSubbrandRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllSubbrandsRaw(requestParameters: GetAllSubbrandsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubbrandLookupResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['brandLookupId'] != null) {
            queryParameters['brandLookupId'] = requestParameters['brandLookupId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subbrand-lookup/subbrands`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubbrandLookupResponseDtoFromJSON));
    }

    /**
     */
    async getAllSubbrands(requestParameters: GetAllSubbrandsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubbrandLookupResponseDto>> {
        const response = await this.getAllSubbrandsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSubbrandRaw(requestParameters: GetSubbrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubbrandLookupResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSubbrand().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subbrand-lookup/subbrands/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubbrandLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getSubbrand(requestParameters: GetSubbrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubbrandLookupResponseDto> {
        const response = await this.getSubbrandRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSubbrandsByBrandRaw(requestParameters: GetSubbrandsByBrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubbrandLookupResponseDto>>> {
        if (requestParameters['brandLookupId'] == null) {
            throw new runtime.RequiredError(
                'brandLookupId',
                'Required parameter "brandLookupId" was null or undefined when calling getSubbrandsByBrand().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subbrand-lookup/subbrands/by-brand/{brandLookupId}`.replace(`{${"brandLookupId"}}`, encodeURIComponent(String(requestParameters['brandLookupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubbrandLookupResponseDtoFromJSON));
    }

    /**
     */
    async getSubbrandsByBrand(requestParameters: GetSubbrandsByBrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubbrandLookupResponseDto>> {
        const response = await this.getSubbrandsByBrandRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateSubbrandRaw(requestParameters: UpdateSubbrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubbrandLookupResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSubbrand().'
            );
        }

        if (requestParameters['updateSubbrandLookupDto'] == null) {
            throw new runtime.RequiredError(
                'updateSubbrandLookupDto',
                'Required parameter "updateSubbrandLookupDto" was null or undefined when calling updateSubbrand().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/subbrand-lookup/subbrands/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubbrandLookupDtoToJSON(requestParameters['updateSubbrandLookupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubbrandLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateSubbrand(requestParameters: UpdateSubbrandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubbrandLookupResponseDto> {
        const response = await this.updateSubbrandRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
